import { TFunction } from 'i18next';

export enum WfFloodCategoryStatus {
  EL = 'EL',
  ES = 'ES',
  Building = 'Building',
  HeatingCooling = 'HeatingCooling',
}

export const WfFloodCategoryStatusMapping = (t: TFunction) => ({
  [WfFloodCategoryStatus.EL]: {
    title: t('wf.statusInformationRegistration.floodCategoryOptions.EL'),
    value: WfFloodCategoryStatus.EL,
  },
  [WfFloodCategoryStatus.ES]: {
    title: t('wf.statusInformationRegistration.floodCategoryOptions.ES'),
    value: WfFloodCategoryStatus.ES,
  },
  [WfFloodCategoryStatus.Building]: {
    title: t('wf.statusInformationRegistration.floodCategoryOptions.building'),
    value: WfFloodCategoryStatus.Building,
  },
  [WfFloodCategoryStatus.HeatingCooling]: {
    title: t('wf.statusInformationRegistration.floodCategoryOptions.heatingCooling'),
    value: WfFloodCategoryStatus.HeatingCooling,
  },
});

export const getFloodCategoryStatusOptions = (t: TFunction) =>
  Object.values(WfFloodCategoryStatusMapping(t));
